
import { createSlice} from "@reduxjs/toolkit";
const getAllworkerDocType = createSlice({
  name: 'getAllworkerDocType',
      initialState:{
        data:null,
        loading:false,
        error:null,
    },
  reducers: {
    fetchData: (state) => {
      state.loading = true;
    },
    fetchDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    reSetData:()=>{
      return []
    }
  },
});
export const { fetchData, fetchDataSuccess, fetchDataError,reSetData } = getAllworkerDocType.actions;
export default getAllworkerDocType.reducer;